import createApiClient from './createGenericApiClient';

const client = createApiClient('billing_base');

export function getBillingClient() {
	return client.getApolloClientInstance();
}

export default client.performRequest;
